import { useState } from 'react'
import { CorporateWellnessGuideCarousel, HubspotBrochureDownload } from '.'
import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'

const CorporateWellnessGuide = (props) => {
  return (
    <>
      <section className="bannerAreaN whiteBackground BannerDeatils mb-5">
        <div className="detailsPageSection">
          <img
            src="https://res.cloudinary.com/vantagecircle/image/upload/v1709807887/VantageFit/2023/background-new.webp"
            alt="corporate wellness"
            className="img-responsive"
            width="1435"
            height="500"
          />
        </div>
        <div className="BannerContent">
          <div className="headingBannerM container customCampaignContainer text-left ">
            <div className="row">
              <div className=" col-lg-8 col-xs-12 col-md-6 col-sm-12 detailbanner">
                <h1>Implementing Corporate Wellness with Vantage Fit</h1>
                <p className="colorwhite mx-auto hero-para font-weight-semibold no-br">
                  This guide will help you learn how Vantage Fit can revolutionize your organization's corporate
                  wellness initiatives and enhance employee health.
                </p>
                <div className="mtb25">
                  <a href="#downloadForm" className="vfitwhitecta scrollToDownload">
                    {' '}
                    Get your Copy{' '}
                  </a>
                </div>
              </div>
              <div className="col-lg-4  col-xs-12 col-md-6 col-sm-12 pclr">
                <img
                  alt="Corporate wellness guide"
                  className="mobileDisplay lozad"
                  loading="lazy"
                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1724932211/VantageFit/2024/Vantage_Fit_Implementation_Guide-Mockup.png"
                  width="404"
                  height="372"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contentmainN ptb0 pt-5">
        <div className="container customCampaignContainer">
          <div className="row d-flex align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 ">
              <div className="subTextHeading text-left">You will get to learn:</div>
              <div>
                <ul className="mainbullets mt-4">
                  <li>How to introduce wellness in your organization</li>
                  <li>How Vantage Fit can help you create engaging wellness campaigns all year long.</li>
                  <li>
                    How you can keep your employees engaged through incentives, recognition, and other strategies.
                  </li>
                  <li>Things to know and expect when planning a wellness campaign.</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center" id="implementationCarousel">
              <CorporateWellnessGuideCarousel />
            </div>
          </div>
        </div>
      </section>
      <div id="downloadForm"></div>
      <section className="sectionSpacing">
        <div className="container customCampaignContainer">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-12 col-lg-6 col-lg-offset-2 text-center shadow"
              style={{ margin: 'auto', borderRadius: '16px', padding: '60px 30px' }}
            >
              <div className="mainHeadingN ">Download Now</div>
              <div className="innerSpace guide-form">
                <HubspotBrochureDownload formID="33312d2f-3e19-4e9e-8751-6a520fc9e0ae" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default CorporateWellnessGuide
